<template>
    <div class="login">
        <Head :loginWeb="true"/>
        <div class="content">
          <div class="content-left">
            <img src="/static/img/pic_bind.png" alt="">
          </div>
          <div class="content-right">
            <Card style="width: 440px">
              <div class="card-top">
                <h1>Enter Your Phone Number</h1>
                <p>绑定手机号</p>
              </div>

              <div>
                <div style="width: 80%;display: flex;margin: 0 auto;justify-content: space-between;align-items: center;">
                  <Select v-model="selectNum" style="width:100px">
                    <Option v-for="item in numList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                  <p>+</p>
                  <Input v-model="phone" placeholder="请输入手机号" style="width: 200px" type="text" :maxlength="11"/>
                </div>
                <div style="width: 80%;display: flex;margin: 0 auto;justify-content: space-between;align-items: center;margin-top:30px;">
                  <Input v-model="code" search prefix="ios-contact" @on-search="getCode()" :enter-button="timeCom" style="width: 100%" :maxlength="6" placeholder="请输入验证码" type="text"/>
                </div>
                <div style="width: 80%;margin: 0 auto;margin-top: 30px;">
                  <Button type="primary" long @click="login()">立即绑定</Button>
                </div>
                  <p style="text-align: center;margin-top: 30px;margin-bottom: 10px;font-size: 12px;color: #b3b3b3">为了获得更好的学习体验<br/> 请补全个人注册信息</p>
              </div>
            </Card>

          </div>
        </div>
    </div>
</template>

<script>
    import {addCookie} from "../../api/cookie";
    import Head from './../../components/Head'
    import ajax from './../../api/ajax'
    export default {
        name: "Login",
        computed:{
          timeCom(){
            if(!this.isSend){
              return '获取验证码'
            }else{
              return `剩余${this.isSendTime}秒`
            }
          },
        },
        data(){
          return{
            isSend:false,  //是否已经输入验证码
            isSendTime:0,  //输入验证码剩余时间
            time:'',
            isSend:false,
            selectNum:86,
            phone:'', //手机号
            code:'',  //验证码
            url:"https://winielts.com",
            numList:[
              {value:86,label:'+86'},
              {value:62,label:'+62'},
              {value:61,label:'+61'},
              {value:60,label:'+60'},
              {value:64,label:'+64'},
              {value:65,label:'+65'},
            ],
          }
        },
        methods:{
          async login(){   //手机号登录
            let reg = /^[1]([3-9])[0-9]{9}$/
            if (!reg.test(this.phone)){
              this.$Message.warning('请输入正确的手机号000')
              return
            }else{
              let reg2 = /^[0-9]*$/
              if (!reg2.test(this.phone)){
                this.$Message.warning('请输入正确的手机号')
                return
              }
            }
            let reg2 = /^\d{6}$/
            if(!reg2.test(this.code)){
              this.$Message.warning('请输入正确的六位数验证码')
              return
            }
            const data = await ajax(this.url + '/api/auth/validationUserPhone',{phone:this.phone,code:this.code,usercode:this.$route.params.userCode},'POST')
            if(data.code === 0){
              let token = data.data.token
              this.$Message.success("成功！")
              addCookie("token",token,30)
              this.$router.push({name:'home'})
            }else{
              this.$Message.warning(data.msg)
            }
          },
          async getCode(){   //手机验证码

            if(!this.isSend){
              if(this.selectNum === 86){
                let reg = /^[1]([3-9])[0-9]{9}$/
                if (!reg.test(this.phone)){
                  this.$Message.warning('请输入正确的手机号111')
                  return
                }
              }else{
                let reg2 = /^[0-9]*$/
                if (!reg2.test(this.phone)){
                  this.$Message.warning('请输入正确的手机号')
                  return
                }
              }
              this.isSendTime = 60
              const data = await ajax(this.url +'/api/message/sendSms',{phone:this.phone,phonecode:this.selectNum},'POST')
              if(data.code === 0){
                this.$Message.success('发送成功！');
                this.time = setInterval(()=>{
                  this.isSendTime--
                  if(this.isSendTime === 0){
                    this.isSend = false
                    clearInterval(this.time)
                    this.isSendTime = 60
                  }
                },1000)
                this.isSend = true
              }else{
                this.$Message.warning(data.msg)
              }
            }else{
              this.$Message.warning(`请等待${this.isSendTime}秒！`)
            }
          },
        },
        components:{
          Head
        }
    }
</script>

<style scoped lang="stylus">
  img
    width auto
  .content
    width 60%
    margin 0 auto
    padding-top: 176px
    display: flex
    justify-content: space-between
  .card-top
    display: flex
    align-items: center
    flex-direction: column
    margin-bottom: 30px
    margin-top 20px
    h1
      font-size: 24px;
      color #333;
      font-weight normal
    p
      font-size: 16px;
      color #808080
</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue